import React from 'react';
import { BannerModule, IBannerProps } from './BannerModule';

export const YellowHighlightBannerModule = React.forwardRef<
  BannerModule,
  Pick<IBannerProps, Exclude<keyof IBannerProps, 'backgroundYellow'>>
>((props, ref) => <BannerModule {...props} ref={ref} backgroundYellow />);
